<script>
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import {
  columns,
  permissionsList,
} from '@/pages/permissions/columns';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'Permissions page',
      columns: columns(),
      permissionsList,
    };
  },
  components: { PageHeader },
  methods: {
    ...mapActions({
      getPermissionsAction: 'permissions/getPermissions',
      updatePermissionAction: 'permissions/updatePermissions',
    }),
    onUpdate(record, column) {
      const role = this.permissions.find((item) => item.name === column.key);
      const newValue = {
        id: role.id,
        permissions: role.permissions,
        pagePermissions: role.pagePermissions,
      };
      if (record.isPage) {
        newValue.pagePermissions = role.pagePermissions.includes(record.dataIndex)
          ? role.pagePermissions.filter((item) => item !== record.dataIndex)
          : [...role.pagePermissions, record.dataIndex];
      } else {
        newValue.permissions = role.permissions.includes(record.dataIndex)
          ? role.permissions.filter((item) => item !== record.dataIndex)
          : [...role.permissions, record.dataIndex];
      }
      this.updatePermissionAction(newValue);
    },
    getColumnValue(column, record) {
      const role = this.permissions.find((itm) => itm.name === column.key)
          || { pagePermissions: [] };
      const rolePermissions = role.permissions || [];
      const rolePagePermissions = role.pagePermissions || [];
      return [...rolePagePermissions, ...rolePermissions].some((item) => item === record.key);
    },
  },
  mounted() {
    this.getPermissionsAction();
  },
  computed: {
    ...mapGetters({
      permissions: 'permissions/sortedPermissions',
    }),
  },
};
</script>

<template>
  <PageHeader :title="title" />
  <div>
    <a-table
      sticky
      :columns="columns"
      :dataSource="permissionsList"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex !== 'title'">
          <a-switch
            checked-children="Yes"
            un-checked-children="No"
            :checked="getColumnValue(column, record)"
            @change="onUpdate(record, column)">
          </a-switch>
        </template>
      </template>
    </a-table>
  </div>
</template>

<style scoped lang="scss">

</style>
